/*
  控制 html 节点挂在 当前节点 还是最外层 document.body
*/
import { createPortal } from 'react-dom';
import { resolveContainer } from './get-container';
import { canUseDom } from './can-use-dom'; // 判断 dom 内容是否合理 portal 到 document.body

export function renderToContainer(getContainer, // 判断是否有 指定挂载的 HTML 节点，如果为 null 的话，会渲染到当前节点
node) {
  if (canUseDom && getContainer) {
    var container = resolveContainer(getContainer);
    return /*#__PURE__*/createPortal(node, container);
  }

  return node;
}